import {
  ActionIcon,
  Divider,
  Flex,
  Group,
  Stack,
  Text,
  Tooltip,
} from "@mantine/core";
import { useEffect, useState } from "react";
import { useListingLoader } from "../../../components/hooks/ListingHooks";
import { getFiles } from "../../../api/FIleAPI";
import FilesContent from "./FilesContent";
import CreateFileButton from "./CreateFileButton";
import { useLanguage } from "../../../stores/LanguageStore";
import { IconArrowLeft, IconSwitchVertical } from "@tabler/icons-react";
import { Link, useNavigate, useParams } from "react-router-dom";
import FoldersDropdown from "../lists/ListingWithContent/contacts/FoldersDropdown";
import NoItemsModal from "../../../components/TableComponents/NoItemsModal";

const imageDef = ["jpg", "jpeg", "png", "gif"];
const codeDef = ["html"];
const powerpointDef = ["pot", "potx", "ppt", "pptx"];
const excelDef = ["xls", "xlsx", "csv"];
const docsDef = ["pdf", "doc", "docx"];
const audioDef = ["mp3", "wav"];

const FilesListing = () => {
  const lang = useLanguage((s) => s.language);
  const { folderId } = useParams();
  const [loading, setLoading] = useState(true);
  const [rows, setRows] = useState([]);

  const navigate = useNavigate();
  const handleSwap = () => {
    navigate("/settings/tools/files/folder/none/file/none");
  };

  useEffect(() => {
    setLoading(true);
  }, [folderId]);

  useListingLoader({
    loading,
    setLoading,
    listGetter: getFiles,
    responseField: "files_list",
    getRows: (result) => {
      const filesWithType = result.map((file) => {
        const fileExtension = file.file_url;
        let type;
        if (imageDef.some((ext) => fileExtension.endsWith(ext))) {
          type = "image";
        }
        if (codeDef.some((ext) => fileExtension.endsWith(ext))) {
          type = "code";
        }
        if (powerpointDef.some((ext) => fileExtension.endsWith(ext))) {
          type = "powerpoint";
        }
        if (excelDef.some((ext) => fileExtension.endsWith(ext))) {
          type = "excel";
        }
        if (docsDef.some((ext) => fileExtension.endsWith(ext))) {
          type = "docs";
        }
        if (audioDef.some((ext) => fileExtension.endsWith(ext))) {
          type = "audio";
        }
        return { ...file, type };
      });

      return filesWithType;
    },
    setRows,
    folderId,
  });

  return (
    <Stack gap={0} pr={48} pt={16} pb={32}>
      {!folderId && (
        <Group gap={"md"}>
          <ActionIcon size={"xl"} component={Link} to={".."}>
            <IconArrowLeft />
          </ActionIcon>
          <Text size="xl" fw={600}>
            {lang.files.browser_tab_title}
          </Text>
          <Tooltip
            label={`${lang.prospects.swap_to} ${lang.prospects.my_folders}`}
          >
            <ActionIcon
              variant="light"
              size={"lg"}
              onClick={handleSwap}
              mr={"auto"}
            >
              <IconSwitchVertical />
            </ActionIcon>
          </Tooltip>

          <CreateFileButton />
        </Group>
      )}

      {folderId && (
        <Group w={"100%"}>
          <Group w={400} mr={"auto"}>
            <FoldersDropdown
              type="File"
              getClickLink={(id) =>
                `/settings/tools/files/folder/${id}/file/none`
              }
              getDeletedLink={() => `/settings/tools/files/folder/none`}
            />
          </Group>
          <CreateFileButton />
        </Group>
      )}

      <Divider mt={16} />

      <Flex h={"100%"} mt={24} w={"100%"} mih={400} pos={"relative"}>
        <NoItemsModal
          rows={rows}
          loading={loading}
          text={
            <Text size="xl" mb={32}>
              {lang.settings.no_files}
            </Text>
          }
          button={<CreateFileButton />}
        />
        <FilesContent
          loading={loading}
          files={rows}
          setLoading={setLoading}
          handleInsertContent={() => { }}
          isTemplate={false}
          handleClose={() => { }}
          isListing
          setRows={setRows}
        />
      </Flex>
    </Stack>
  );
};

export default FilesListing;
